var map = {
	"./border/border_no.png": 1600,
	"./border/border_yes.png": 2436,
	"./font/Standard.png": 8043,
	"./font/letter-carbon.png": 4407,
	"./font/letter-chrome.png": 7704,
	"./font/letter-hiline.png": 2184,
	"./logo/England.png": 9785,
	"./logo/None.png": 6903,
	"./logo/Scotland.png": 3785,
	"./logo/UK.png": 1010,
	"./logo/Wales.png": 4516,
	"./logo/ev.png": 3633,
	"./logo/flag-eu.png": 1077,
	"./option-border.png": 6605,
	"./option-flag.png": 1481,
	"./option-font.png": 5180,
	"./option-size.png": 5342,
	"./size/Large.png": 5766,
	"./size/Motorbike.png": 5789,
	"./size/Regular.png": 6048,
	"./size/Square.png": 107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9141;